module.exports = __webpack_public_path__ + "static/media/angular.fb422292.webp";